import React, { Component } from 'react';

class ConfigureItem extends Component {
    render() {
        const { item, index, onChange, keys } = this.props
        return (
            <div className='flexLayout line-item'>
                {
                    keys.map((k, i) => (
                        <div key={`input_${k.name}_${i}`} className={`count ${k.className}`}>
                            <input value={item[k.name]} name={k.name} type={k.type} step={k.step} onChange={(e) => {
                                const val = { ...item }
                                val[k.name] = e.target.value || null
                                onChange(val, index)
                            }} />
                        </div>
                    ))
                }
                <button className='reduce-button' style={{ width: 50 }} type='button' onClick={() => this.props.onDelete(index)}>
                    <img src={process.env.PUBLIC_URL + '/images/reduce.svg'} style={{ height: '100%' }} alt="loading" />
                </button>
            </div>
        );
    }
}

export default ConfigureItem;